"use client";
import {
  GroupLabelContext
} from "./3X3MDQGM.js";
import {
  createComponent,
  createElement,
  createHook
} from "./LFJDOMBA.js";
import {
  useWrapElement
} from "./6WEF4WY5.js";
import {
  __spreadValues
} from "./2SMRF6AD.js";

// src/group/group.tsx
import { useState } from "react";
import { jsx } from "react/jsx-runtime";
var useGroup = createHook((props) => {
  const [labelId, setLabelId] = useState();
  props = useWrapElement(
    props,
    (element) => /* @__PURE__ */ jsx(GroupLabelContext.Provider, { value: setLabelId, children: element }),
    []
  );
  props = __spreadValues({
    role: "group",
    "aria-labelledby": labelId
  }, props);
  return props;
});
var Group = createComponent((props) => {
  const htmlProps = useGroup(props);
  return createElement("div", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  Group.displayName = "Group";
}

export {
  useGroup,
  Group
};
